export const SIGN_UP_COPY = {
	PARTIAL_AGREEMENT: 'I agree to the ',
	SIGN_UP: 'Sign Up',
	SIGN_UP_FOR_AROVY: 'Sign Up for Arovy'
};
